import React, { Dispatch } from "react";
import { connect } from "react-redux";

import services from "./services";
import MainContainer from "./components/Main/Main.Container";
import socketTest from ".";
import { MessagesActions } from "./states/Messages/MessagesState";
import { debounce } from "lodash";
// import { Flex } from "@twilio/flex-ui";
import { Phone } from "../utils/Phone";
import { store } from "../states";
import { User, WorkspaceAccess } from "./states/WorkspacesState";
import { WorkspaceActions } from "./states/WorkspacesState";
import { TechnicianContactsActions } from "./states/Contacts/TechnicianContactsState";
import { CustomerContactsActions } from "./states/Contacts/CustomerContactsState";
import LS from "../utils/LocalStorageManager";

type AdapterState = {
  user: any;
  loading: boolean;
  error: string | null;
};

interface IProps {
  user: User | null;
}

class Adapter extends React.Component<IProps, AdapterState> {
  private _isMounted = false;

  state: AdapterState = {
    user: null,
    loading: true,
    error: null,
  };

  async componentDidMount() {
    this._isMounted = true;
    try {
      if (!this.props.user) throw new Error("Unloaded user");
      const worker = await services.getUserByEmail(this.props.user.email);
      const fullName = worker?.full_name || "";
      const email = worker?.email || "";
      const sid = worker?.agent_id || "";
      const workerPhone = new Phone(worker?.source?.phone || "").normalized();
      const userDepartments = worker?.departments || [];

      socketTest.authUser(
        fullName,
        email,
        sid,
        workerPhone,
        userDepartments,
        worker?.source
      );

      socketTest.checkWorkspaceAccess((accessInfo: WorkspaceAccess) => {
        store.dispatch(WorkspaceActions.setAccess(accessInfo.hasAccess));
        store.dispatch(WorkspaceActions.loadUsers(accessInfo.workspaces));
      });

      socketTest.requestContacts((contacts) => {
        store.dispatch(TechnicianContactsActions.loadContacts(contacts));
        store.dispatch(CustomerContactsActions.loadContacts(contacts));
      });

      socketTest.subscribeResultOutboundMessages((messagesForContact) => {
        store.dispatch(
          TechnicianContactsActions.loadMessages(messagesForContact)
        );
        store.dispatch(
          CustomerContactsActions.loadMessages(messagesForContact)
        );
      });
      socketTest.subscribeTypingData((typingData) => {
        const mySender = LS.getSender();
        const mySenderPhone = new Phone(mySender?.phone || "").normalized();
        const targetUserPhone = new Phone(
          typingData?.user?.phone || ""
        ).normalized();
        const typingCustomSender = typingData?.customSender || null;

        // Если кто-то печатает в чате с моим открытым контактом, находясь в том же департаменте, что и я - показываем уведомление
        if (
          typingCustomSender &&
          mySender &&
          typingCustomSender.phone === mySenderPhone &&
          workerPhone !== targetUserPhone
        ) {
          console.log("TYPE::NOTIFY::RECEIVE: ", typingData);
          store.dispatch(MessagesActions.setTypingState(typingData));
        }
        // debouncedNullTyping();
      });
      socketTest.subscribeToOutboundMessages(store);
      socketTest.subscribeIncomingMessages(store);
      socketTest.subscribeMessageStatusUpdating(store);

      if (this._isMounted) this.setState({ user: worker, loading: false });
    } catch (e) {
      if (this._isMounted) this.setState({ error: "Failed to load user" });
    } finally {
      if (this._isMounted) this.setState({ loading: false });
    }
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  render() {
    const { user, loading, error } = this.state;
    if (loading) return <div>Loading user…</div>;
    if (error) return <div>{error}</div>;
    // return <pre>{JSON.stringify(user, null, 2)}</pre>;
    return (
      <div style={{ position: "relative", height: "calc(100vh - 100px)" }}>
        <MainContainer />
      </div>
    );
  }
}

//export default Adapter;

const mapStateToProps = (state: any) => {
  return {
    user: state.auth.user,
  };
};

const mapDispatchToProps = (dispatch: Dispatch<any>) => ({
  // setUser: bindActionCreators(AuthStateActions.setUser, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(Adapter);
